import { render, staticRenderFns } from "./ReporteCumplimientoExport.vue?vue&type=template&id=246f2b28"
import script from "./ReporteCumplimientoExport.vue?vue&type=script&lang=js"
export * from "./ReporteCumplimientoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports